export default "__VITE_ASSET__CJLrrAo6__"